"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeInResponseMapper = void 0;
var TradeInResponseMapper = /** @class */ (function () {
    function TradeInResponseMapper(data) {
        this.localData = data;
    }
    TradeInResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return TradeInResponseMapper;
}());
exports.TradeInResponseMapper = TradeInResponseMapper;
//# sourceMappingURL=TradeInResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/TradeInResponseMapper.js
// module id = 2212
// module chunks = 8